// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i3yNK","col":"styles_col__3qFKF"};